import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Institution } from '../components/select-institution/institution.model';
import { AuthService } from './auth.service';
import { StudyPlan } from '../components/select-study-plan/study-plan.model';
import { Business } from '../../pages/users/user.model';
import { SchoolModule } from '../components/select-module/module.model';

@Injectable({
    providedIn: 'root'
})
export class GeneralService {
    public static chats: Institution[];

    public urlBase = '/api/';
    private readonly urlMail = '/mail/';
    constructor(public http: HttpClient) { }

    getInstitution(businessName: string): Observable<Institution[]> {
        return this.http.get<Institution[]>(this.urlBase + 'getInstitutions?businessName=' + businessName);
    }

    getStudentInfo(business_id: number, matcatalu: string): Observable<any>{
        return this.http.get<any>(this.urlBase + 'getStudentInfoByMatcatalu?matcatalu=' + matcatalu + '&business=' + business_id);
      }

    getStudyPlans(businessName: string): Observable<StudyPlan[]> {
        return this.http.get<StudyPlan[]>(this.urlBase + 'getStudyPlans?businessName=' + businessName);
    }

    getBusiness(): Observable<Business[]> {
        return this.http.get<Business[]>(this.urlBase + 'getBusiness');
    }

    getSchoolModules(business: string): Observable<SchoolModule[]> {
        return this.http.get<SchoolModule[]>(this.urlBase + 'getSchoolModules?business=' + business);
    }

    getCurrentModule(): Observable<any> {
        return this.http.get<any>(this.urlBase + 'getCurrentModule');
    }

    getGeneralQualifications(businessName: string, instId: number, planId: number, type: number, userId: number) {
        return this.http.get(this.urlBase + 'getGeneralQualifications?businessName=' + businessName + '&instId=' + instId + '&planId=' + planId + '&type=' + type + '&userId=' + userId);
    }

    sendMail(data): Observable<any>{
        const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/x-www-form-urlencoded'
            })
          };
        return this.http.post(this.urlMail + 'send', data);
    }

    /*getEmailsCC(): Observable<any>{
        return this.http.get<any>(this.urlBase + 'getEmailsCC');
    }*/
    
    getGeneralQualificationsCycle(businessName: string, instId: number, planId: number , type: number , rvoe:string, userId: number) {
        return this.http.get(this.urlBase + 'getGeneralQualificationsCycle?businessName=' + businessName + '&instId=' + instId + '&planId=' + planId + '&type=' + type + '&rvoe=' + rvoe +'&userId=' + userId);
    }
    getInstForQualificationReport(businessName: string): Observable<Institution[]> {
        return this.http.get<Institution[]>(this.urlBase + 'getInstForQualificationReport?businessName=' + businessName);
    }
    getPLaForQualificationReport(businessName: string,inst_id:Number): Observable<StudyPlan[]> {
        return this.http.get<StudyPlan[]>(this.urlBase + 'getPLaForQualificationReport?businessName=' + businessName +'&inst_id=' +inst_id);
    }

    getDocumentationNotifications(business: number, registration): Observable<any>{
        return this.http.get<any>(this.urlBase + 'getDocumentationNotifications?business=' + business + '&registration=' + registration);
    }

    downloadAccountStatus(data: any): Observable<any>{
        return this.http.post<any>(this.urlBase + 'downloadAccountStatus', data);
    }

    getEducationalModel(): Observable<object> {
        return this.http.get(this.urlBase + 'getEducationalModel');
      }

    getDocumentInfo(id: string): Observable<any>{
        return this.http.get(this.urlBase + 'getDocumentInfo?id=' + id);
    }
    getListRVOE(): Observable<object> {
        return this.http.get(this.urlBase + 'getListRVOE');
      }
    
    createUserIncurso(matricula: String){
        return this.http.post(this.urlBase + 'createUserIncurso', {matricula: matricula});
    }
    
    updateStudentInfo(data: any): Observable<any>{
        return this.http.post(this.urlBase + 'updateStudentInfo', data);
    }

    acceptNotificationDocs = (data: any) => {
        return this.http.post(this.urlBase + 'acceptNotify', data);
    }

    // Reglamento vigente en base64 (misma fuente que "Mis documentos": DocumentosInicio)
    getRegulationDocument(business: number, nivelId: number, idecatalu?: number): Observable<any> {
        const params: any = {
            business: business.toString(),
            nivel_id: nivelId.toString()
        };
        if (idecatalu) {
            params.idecatalu = idecatalu.toString();
        }

        return this.http.get<any>(this.urlBase + 'getRegulationDocument', { params });
    }
}
